// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.1 on 2026-03-26T12:00:00.000Z

// Connected to gst-prod account (962800862698), prod stage
const awsmobile = {
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_graphqlEndpoint: 'https://zlzrxvcmqfenhdyg5bkfuulvca.appsync-api.eu-central-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-central-1',
    aws_cognito_region: 'eu-central-1',
    aws_project_region: 'eu-central-1',
    aws_user_files_s3_bucket: 'gst-backend-prod-uploads',
    aws_user_files_s3_bucket_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_cw7iuZFwZ',
    aws_user_pools_web_client_id: '58mkvrq1h82rqkp4t97kagegoc'
};

export default awsmobile;
